module.exports = __webpack_public_path__ + "img/1.7_Russian_road_sign.753bd08e.svg";